import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from "react-responsive-carousel";
import ClarkeQuay from "../images/ClarkeQuay@2x.jpeg";
import GardensByTheBay from "../images/GardensByTheBay@2x.jpeg";
import KampongGlam from "../images/KampongGlam@2x.jpeg";
import changiIcon from "../images/changiLogoReversed.png";
import { useState } from "react";

const ImageCarousel = () => {
  const [place, setPlace] = useState("Clarke Quay");
  const [timePlace, setTimePlace] = useState("24 mins from Changi Airport");

  return (
    <div className="fixed z-0 h-full">
      <div>
        <Carousel
          autoPlay
          showThumbs={false}
          showArrows={false}
          showIndicators={false}
          showStatus={false}
          swipeable={false}
          animationHandler="fade"
          interval={5000}
          verticalSwipe={"natural"}
          infiniteLoop
          className="h-screen w-screen"
          onChange={(index) => {
            index === 0
              ? setPlace("Clarke Quay")
              : index === 1
              ? setPlace("Gardens By The Bay")
              : setPlace("Kampong Glam");

            index === 0
              ? setTimePlace("24 mins from Changi Airport")
              : index === 1
              ? setTimePlace("22 mins from Changi Airport")
              : setTimePlace("17 mins from Changi Airport");
          }}
        >
          <div>
            <img
              src={ClarkeQuay}
              className="h-screen object-cover brightness-90"
            />
          </div>
          <div>
            <img
              src={GardensByTheBay}
              className="h-screen object-cover brightness-90"
            />
          </div>
          <div>
            <img
              src={KampongGlam}
              className="h-screen object-cover brightness-90"
            />
          </div>
        </Carousel>
      </div>
      <div className="flex items-center justify-between px-[30px] absolute inset-x-0 bottom-0 h-16 z-0 pb-10">
        <div className="flex flex-col text-white text-sm">
          <div className="font-bold">{place}</div>
          <div className="font-normal">{timePlace}</div>
        </div>
        <img src={changiIcon} />
      </div>
    </div>
  );
};

export default ImageCarousel;
